import { Badge, Col, Card, CardBody, CardLink, CardText } from 'reactstrap'
import Link from 'next/link'

function ScpAppCard ({ app }) {
  const { id, name } = app

  return (
    <>
      <Col sm='6' md='4' lg='3' className='py-2'>
        <Card>
          <CardBody className='topic-item-body'>
            <i className='fa fa-content-copy topic-icon' />
            <CardText>
              <Link key={id} href='/tos/app/[id]' as={`/tos/app/${id}`} passHref>
                <a>
                  <Badge color='primary' pill className='mr-1 mt-1'>
                    {name}
                  </Badge>
                </a>
              </Link>
            </CardText>
            <CardText>
              <Link href={{ pathname: '/tos/app/[id]' }} as={{ pathname: `/tos/app/${id}` }} passHref>
                <CardLink>View</CardLink>
              </Link>
            </CardText>
          </CardBody>
        </Card>
      </Col>
    </>
  )
}

export default ScpAppCard
